import { Filter } from '@common/filter/types';

/**
 * Validate that a filter has value and mode set (i.e. is not empty).
 *
 * To be used after a user has created a filter in the filter overlay, because
 * these have no mode and value by default
 */
export const validateFilterHasValues = ({ value: { value, mode } }: Pick<Filter, 'value'>): boolean =>
  Boolean(mode && value && value.length);
